import { Create, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Form, Input, InputNumber, Switch } from "antd";
import { ImageUpload } from "../../components/ImageUpload";

export function CardTemplateCreate() {
  const { formProps, saveButtonProps, formLoading } = useForm<
    any,
    HttpError,
    any
  >({
    resource: "card-template",
    successNotification: (data) => ({
      message: data?.data.message,
      type: "success",
    }),
    action: "create",
  });

  return (
    <Create
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      title="Create card template"
    >
      <Form {...formProps} layout="vertical">
        <Form.Item label="Title" name={["title"]} rules={[{ required: true }]}>
          <Input placeholder="Standard" />
        </Form.Item>

        <Form.Item
          label="Description"
          name={["description"]}
          rules={[{ required: true }]}
        >
          <Input placeholder="Starter edition" />
        </Form.Item>

        <Form.Item
          label="Coach line"
          name={["coachLine"]}
          rules={[{ required: true }]}
          tooltip="The long line Coach Eoin types when this template is active."
        >
          <Input.TextArea
            rows={3}
            placeholder="This is the Standard card. Clean and classic, a solid place to start."
          />
        </Form.Item>

        <Form.Item
          label="Primary colour"
          name={["primaryColor"]}
          rules={[
            { required: true },
            {
              pattern: /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/,
              message: "Hex colour, e.g. #C6F24E",
            },
          ]}
          tooltip="Glow colour displayed behind the card."
        >
          <Input placeholder="#C6F24E" />
        </Form.Item>

        <Form.Item
          label="Display image (PNG)"
          name="displayImageID"
          rules={[{ required: true, message: "Upload the display image" }]}
        >
          <ImageUpload uploadType="CARD_TEMPLATE" accept="image/*" />
        </Form.Item>

        <Form.Item
          label="Fillable SVG"
          name="fillableSvgID"
          rules={[
            { required: true, message: "Upload the fillable SVG template" },
          ]}
          tooltip="SVG template with placeholder tokens (__PLAYER_NAME__, __STAT_V1__, …) filled client-side."
        >
          <ImageUpload uploadType="CARD_TEMPLATE" accept="image/svg+xml,.svg" />
        </Form.Item>

        <Form.Item
          label="XP threshold"
          name={["xpThreshold"]}
          initialValue={0}
          tooltip="Minimum lifetime training XP required to unlock this card level."
        >
          <InputNumber min={0} step={250} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Priority"
          name={["priority"]}
          initialValue={0}
          tooltip="Deck order — lower shows first (0 = leftmost)."
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Active"
          name={["isActive"]}
          valuePropName="checked"
          initialValue={true}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  );
}
